import { IPublicTypeLocationDetailType } from '@alilc/lowcode-types';
export function isLocationChildrenDetail(obj) {
  return obj && obj.type === IPublicTypeLocationDetailType.Children;
}